export const setupCsrfToken = (axiosInstance) => {
    const tokenElement = document.querySelector('meta[name="csrf-token"]');
    const tokenValue = tokenElement?.getAttribute('content');
    if (tokenValue) {
        axiosInstance.defaults.headers['X-CSRF-Token'] = tokenValue;
    }
};
//# sourceMappingURL=setupCsrfToken.js.map